// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.products-title {
  display: flex;
  width: 100vw;
  justify-content: center;
  color: #247a97;
  font-size: 3rem;
  font-weight: 900;
  margin-top: 5rem;
  margin-bottom: 5rem;
  font-style: italic;
  align-items: center;
}

/* Badge base styles */
.badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  width: -moz-fit-content;
  width: fit-content;
  padding: 0 0.563rem;
  border-width: 1px;
  border-color: #334155;
  background-color: #64748b;
  color: #e2e8f0;
  border-radius: 1.9rem;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
}

/* Badge ghost variant */
.badge-ghost {
  border-color: #64748b;
  background-color: transparent;
  color: #334155;
}

/* Define CSS variables in root if needed */
:root {
  --b1: 215, 28%, 17%;
  --b2: 215, 28%, 10%;
  --bc: 218, 6%, 82%;
  --rounded-badge: 1.9rem;
}

/* Apply the defined CSS variables */
.badge {
  border-color: hsl(var(--b2));
  background-color: hsl(var(--b1));
  color: hsl(var(--bc));
  border-radius: var(--rounded-badge);
}

.badge-ghost {
  border-color: hsl(var(--b2));
  color: hsl(var(--bc));
}

/* General Styles */
.products-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
  justify-content: center;
  padding: 1rem;
  margin-left: 15vw;
  margin-right: 15vw;
}

/* Category Selector */
.selectectCat {
  width: 30vw;
  display: flex;
  align-items: center;
  border: 1px solid #d1d5db;
  background-color: #f9fafb;
  font-size: 1rem;
  font-weight: normal;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  color: #374151;
  margin: 10px 0;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.selectectCat:hover {
  background-color: #eff6ff;
}

/* Search Bar */
.join {
  width: 40vw;
  display: flex;
  align-items: center;
  border: 1px solid #d1d5db;
  background-color: #f9fafb;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  color: #374151;
}

/* Pagination Styles */
.assigned-name {
  display: flex;
  justify-content: center;
  margin-top: 3rem;
  align-items: center;
}

.assigned-name .page-class {
  margin-left: 1rem;
  margin-right: 1rem;
}

.pagination-active {
  background-color: #3b82f6;
  color: #ffffff;
  border-radius: 0.375rem;
}

.pagination-page {
  font-size: 1rem;
  margin: 0 0.75rem;
  border-radius: 0.375rem;
}

.pagination-previous,
.pagination-next {
  display: flex;
  align-items: center;
  margin: 0 2rem;
  color: #374151;
}

/* Card Styles */
.card-container {
  margin: 4px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.card {
  width: 16rem;
  margin: 1rem;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 1rem;
  background-color: #939393;
  background-image: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.3) 0%,
      transparent 100%
    ),
    linear-gradient(to right, rgba(255, 255, 255, 0.1) 25%, transparent 25%);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1) inset,
    0 0 0 2px rgba(0, 0, 0, 0.05);
  border: none;
  -webkit-backdrop-filter: blur(40px);
  backdrop-filter: blur(40px);
  overflow: hidden;
}

.figure-container {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.figure-img {
  width: 100%;
  height: auto;
  display: block;
  -o-object-fit: cover;
     object-fit: cover;
}

.card-body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  padding: var(--padding-card, 2rem);
  gap: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
}

.card-text {
  position: absolute;
  bottom: 35%;
  left: 0;
  width: 100%;
  background: #939393;
  color: white;
  padding: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 1rem;
  padding: 0.5rem;
}

.card-options {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

/* Average Rating Styles */
.avgrating {
  display: flex;
  width: 100%;
  align-items: center;
}

.actual-rating {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.badge {
  font-size: 1rem;
  font-weight: normal;
  color: #ffffff;
}

.prod-price {
  font-size: 1.5rem;
  font-weight: bold;
  color: #ffffff;
  padding: 0.5rem;
}

/* Add to Cart and Wishlist button styles */
.add-to-cart,
.wishlist-button {
  background-color: #d1d5db;
  color: white;
  padding: 0.5rem;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  transition: background-color 0.3s ease;
}

.add-to-cart:hover,
.wishlist-button:hover {
  background-color: #059669;
}

/* Media Queries for Responsive Design */
@media (max-width: 640px) {
  .selectectCat,
  .join {
    width: 100vw;
  }

  .card {
    width: 100%;
    margin: 0.5rem 0;
  }

  .assigned-name {
    flex-direction: column;
  }

  .sm\\:card-normal .card-body {
    padding: var(--padding-card, 2rem);
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

.card-compact .card-body {
  padding: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.glass,
.glass.btn-active {
  border: none;
  -webkit-backdrop-filter: blur(40px);
  backdrop-filter: blur(40px);
  background-color: transparent;
  background-image: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.3) 0%,
      transparent 100%
    ),
    linear-gradient(100deg, rgba(255, 255, 255, 0.1) 25%, transparent 25%);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1) inset,
    0 0 0 2px rgba(0, 0, 0, 0.05);
  text-shadow: 0 1px rgba(0, 0, 0, 0.05);
}

@media screen and (max-width: 991px) {
  .selectectCat {
    width: 35vw;
    /* width: 30vw;
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: #f9fafb; */
    font-size: 2.5rem;
    /* font-weight: normal;
    padding: 0.5rem 1rem;
    border-radius: 0.375rem;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    color: #374151;
    margin: 10px 0;
    cursor: pointer;
    transition: background-color 0.3s ease; */
  }

  .selectectCat:hover {
    background-color: #eff6ff;
  }

  .search-icon {
    transform: scale(2.5);
  }

  /* Search Bar */
  .join {
    /* width: 40vw;
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: #f9fafb; */
    font-size: 2.5rem;
    /* padding: 0.5rem 1rem;
    border-radius: 0.375rem;
    color: #374151; */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/Products.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,2CAA2C;EAC3C,cAAc;EACd,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB;;;;;4EAK0E;EAC1E;iCAC+B;EAC/B,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAiB;KAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,kCAAkC;EAClC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;;EAEE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,sCAAsC;AACxC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,wCAAwC;AACxC;EACE;;IAEE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kCAAkC;IAClC,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,6BAA6B;EAC7B;;;;;0EAKwE;EACxE;iCAC+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE;IACE,WAAW;IACX;;;;gCAI4B;IAC5B,iBAAiB;IACjB;;;;;;;6CAOyC;EAC3C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA,eAAe;EACf;IACE;;;;gCAI4B;IAC5B,iBAAiB;IACjB;;qBAEiB;EACnB;AACF","sourcesContent":[".products-title {\n  display: flex;\n  width: 100vw;\n  justify-content: center;\n  color: #247a97;\n  font-size: 3rem;\n  font-weight: 900;\n  margin-top: 5rem;\n  margin-bottom: 5rem;\n  font-style: italic;\n  align-items: center;\n}\n\n/* Badge base styles */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 1.25rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  width: fit-content;\n  padding: 0 0.563rem;\n  border-width: 1px;\n  border-color: #334155;\n  background-color: #64748b;\n  color: #e2e8f0;\n  border-radius: 1.9rem;\n  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Badge ghost variant */\n.badge-ghost {\n  border-color: #64748b;\n  background-color: transparent;\n  color: #334155;\n}\n\n/* Define CSS variables in root if needed */\n:root {\n  --b1: 215, 28%, 17%;\n  --b2: 215, 28%, 10%;\n  --bc: 218, 6%, 82%;\n  --rounded-badge: 1.9rem;\n}\n\n/* Apply the defined CSS variables */\n.badge {\n  border-color: hsl(var(--b2));\n  background-color: hsl(var(--b1));\n  color: hsl(var(--bc));\n  border-radius: var(--rounded-badge);\n}\n\n.badge-ghost {\n  border-color: hsl(var(--b2));\n  color: hsl(var(--bc));\n}\n\n/* General Styles */\n.products-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 1rem;\n  justify-content: center;\n  padding: 1rem;\n  margin-left: 15vw;\n  margin-right: 15vw;\n}\n\n/* Category Selector */\n.selectectCat {\n  width: 30vw;\n  display: flex;\n  align-items: center;\n  border: 1px solid #d1d5db;\n  background-color: #f9fafb;\n  font-size: 1rem;\n  font-weight: normal;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  color: #374151;\n  margin: 10px 0;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.selectectCat:hover {\n  background-color: #eff6ff;\n}\n\n/* Search Bar */\n.join {\n  width: 40vw;\n  display: flex;\n  align-items: center;\n  border: 1px solid #d1d5db;\n  background-color: #f9fafb;\n  font-size: 1rem;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  color: #374151;\n}\n\n/* Pagination Styles */\n.assigned-name {\n  display: flex;\n  justify-content: center;\n  margin-top: 3rem;\n  align-items: center;\n}\n\n.assigned-name .page-class {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n.pagination-active {\n  background-color: #3b82f6;\n  color: #ffffff;\n  border-radius: 0.375rem;\n}\n\n.pagination-page {\n  font-size: 1rem;\n  margin: 0 0.75rem;\n  border-radius: 0.375rem;\n}\n\n.pagination-previous,\n.pagination-next {\n  display: flex;\n  align-items: center;\n  margin: 0 2rem;\n  color: #374151;\n}\n\n/* Card Styles */\n.card-container {\n  margin: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.card {\n  width: 16rem;\n  margin: 1rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  border-radius: 1rem;\n  background-color: #939393;\n  background-image: linear-gradient(\n      135deg,\n      rgba(255, 255, 255, 0.3) 0%,\n      transparent 100%\n    ),\n    linear-gradient(to right, rgba(255, 255, 255, 0.1) 25%, transparent 25%);\n  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1) inset,\n    0 0 0 2px rgba(0, 0, 0, 0.05);\n  border: none;\n  -webkit-backdrop-filter: blur(40px);\n  backdrop-filter: blur(40px);\n  overflow: hidden;\n}\n\n.figure-container {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.figure-img {\n  width: 100%;\n  height: auto;\n  display: block;\n  object-fit: cover;\n}\n\n.card-body {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  padding: var(--padding-card, 2rem);\n  gap: 0.5rem;\n  font-size: 1rem;\n  line-height: 1.5rem;\n}\n\n.card-text {\n  position: absolute;\n  bottom: 35%;\n  left: 0;\n  width: 100%;\n  background: #939393;\n  color: white;\n  padding: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.card-actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 0.5rem;\n}\n\n.card-options {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n\n/* Average Rating Styles */\n.avgrating {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n\n.actual-rating {\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: auto;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.badge {\n  font-size: 1rem;\n  font-weight: normal;\n  color: #ffffff;\n}\n\n.prod-price {\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: #ffffff;\n  padding: 0.5rem;\n}\n\n/* Add to Cart and Wishlist button styles */\n.add-to-cart,\n.wishlist-button {\n  background-color: #d1d5db;\n  color: white;\n  padding: 0.5rem;\n  border-radius: 50%;\n  cursor: pointer;\n  border: none;\n  transition: background-color 0.3s ease;\n}\n\n.add-to-cart:hover,\n.wishlist-button:hover {\n  background-color: #059669;\n}\n\n/* Media Queries for Responsive Design */\n@media (max-width: 640px) {\n  .selectectCat,\n  .join {\n    width: 100vw;\n  }\n\n  .card {\n    width: 100%;\n    margin: 0.5rem 0;\n  }\n\n  .assigned-name {\n    flex-direction: column;\n  }\n\n  .sm\\:card-normal .card-body {\n    padding: var(--padding-card, 2rem);\n    font-size: 1rem;\n    line-height: 1.5rem;\n  }\n}\n\n.card-compact .card-body {\n  padding: 1rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n\n.glass,\n.glass.btn-active {\n  border: none;\n  -webkit-backdrop-filter: blur(40px);\n  backdrop-filter: blur(40px);\n  background-color: transparent;\n  background-image: linear-gradient(\n      135deg,\n      rgba(255, 255, 255, 0.3) 0%,\n      transparent 100%\n    ),\n    linear-gradient(100deg, rgba(255, 255, 255, 0.1) 25%, transparent 25%);\n  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1) inset,\n    0 0 0 2px rgba(0, 0, 0, 0.05);\n  text-shadow: 0 1px rgba(0, 0, 0, 0.05);\n}\n\n@media screen and (max-width: 991px) {\n  .selectectCat {\n    width: 35vw;\n    /* width: 30vw;\n    display: flex;\n    align-items: center;\n    border: 1px solid #d1d5db;\n    background-color: #f9fafb; */\n    font-size: 2.5rem;\n    /* font-weight: normal;\n    padding: 0.5rem 1rem;\n    border-radius: 0.375rem;\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n    color: #374151;\n    margin: 10px 0;\n    cursor: pointer;\n    transition: background-color 0.3s ease; */\n  }\n\n  .selectectCat:hover {\n    background-color: #eff6ff;\n  }\n\n  .search-icon {\n    transform: scale(2.5);\n  }\n\n  /* Search Bar */\n  .join {\n    /* width: 40vw;\n    display: flex;\n    align-items: center;\n    border: 1px solid #d1d5db;\n    background-color: #f9fafb; */\n    font-size: 2.5rem;\n    /* padding: 0.5rem 1rem;\n    border-radius: 0.375rem;\n    color: #374151; */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
